import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-gdo-shared',
    templateUrl: './gdo-shared.component.html',
    styleUrls: ['./gdo-shared.component.scss'],
    standalone: false
})
export class GdoSharedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
